<template>
    <div class="main-container">
        <div class="filter-container">
            <el-select class="filter-item" style="width:150px" v-model="filters.date"  placeholder="时间（月份）">
                    <el-option v-for="item in dateList" :key="item.id" :label="item.value" :value="item.value"></el-option>
                </el-select>
            <el-select class="filter-item" v-model="filters.order_type" placeholder="订单类型" style="width:150px">
                <el-option label="全部" value="2"></el-option>
                <el-option label="实物订单" value="0"></el-option>
                <el-option label="自制电子券订单" value="1"></el-option>
            </el-select>
            <el-select class="filter-item" v-model="filters.status" placeholder="对账状态" style="width:150px">
                <el-option label="全部" value="2"></el-option>
                <el-option label="未对账" value="0"></el-option>
                <el-option label="对账完成" value="1"></el-option>
            </el-select>
            <el-select class="filter-item" v-model="filters.remittance_status" placeholder="汇款状态" style="width:150px">
                <el-option label="全部" value="2"></el-option>
                <el-option label="未回款" value="0"></el-option>
                <el-option label="汇款完成" value="1"></el-option>
            </el-select>
            <el-select class="filter-item" v-model="filters.invoice_type" placeholder="是否添加发票" style="width:150px">
                <el-option label="全部" value="2"></el-option>
                <el-option label="未添加" value="0"></el-option>
                <el-option label="已添加" value="1"></el-option>
            </el-select>
            <el-button class="filter-btn" type="primary" @click="search()">搜索</el-button>
            <el-button class="filter-btn" type="primary" @click="exportType=0; onExport()">导出</el-button>
            <el-button class="filter-btn" type="primary" @click="exportType=1; onDialogShow()">结算订单导出</el-button>
            <el-button class="filter-btn" type="primary" @click="exportType=2; onDialogShow()">退款订单导出</el-button>
            <el-button class="filter-btn" type="primary" @click="exportType=3; onDialogShow()">渠道卡券Sass订单导出</el-button>

        </div>
        <el-table :data="tableData" stripe border style="width:100%">
            <el-table-column prop="brand_id" label="品牌ID"></el-table-column>
            <el-table-column prop="brand_name" label="品牌"></el-table-column>
            <el-table-column prop="cat_id" label="分类"></el-table-column>
            <el-table-column prop="shop_discount" label="品牌折扣"></el-table-column>
            <el-table-column prop="invoice_type" label="专票/普票" width="90"></el-table-column>
            <el-table-column prop="tax_Point" label="品牌税点"></el-table-column>
            <el-table-column prop="status" label="订单类型">
                <template #default="scope">
                    <span v-if="scope.row.order_type == 1">自制电子券订单</span>
                    <span v-if="scope.row.order_type == 0">实物订单</span>
                </template>
            </el-table-column>
            <el-table-column prop="jiesuan_amount" label="结算金额"></el-table-column>
            <el-table-column prop="date" label="账期"></el-table-column>
            <el-table-column prop="invoice_time" label="收票时间" width="110"></el-table-column>
            <el-table-column prop="remittance_time" label="汇款时间" width="110"></el-table-column>
            <el-table-column label="操作" width="300">
                <template #default="scope">
                    <div class="action-list">
                        <el-tag v-if="scope.row.invoice_status==0" @click="onOrderChange(scope.row.id, 1)" size="small">确认已收到发票</el-tag>
                        <el-tag v-else type="info" size="small">已收到发票</el-tag>

                        <el-tag v-if="scope.row.remittance_status==0" @click="onOrderChange(scope.row.id, 2)" size="small">确认已汇款</el-tag>
                        <el-tag v-else type="info" size="small">已汇款</el-tag>
                    
                        <router-link :to="`/invoice/uploadinvoice?id=${scope.row.id}`" v-if="scope.row.invoice_id == null">
                            <el-tag size="small">上传发票</el-tag>
                        </router-link>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <Pagination :currentPage="filters.currentPage" :total="count" @pageChange="onPageChange" @sizeChange="onSizeChange" />

        <el-dialog :title="exportArray[exportType]" v-model="dialogVisible" width="80%">
            <el-form :inline="true" label-width="60px">
                <el-form-item label="渠道">
                    <el-select v-model="channel_no" filterable placeholder="请选择渠道">
                        <el-option
                            v-for="item in channelList"
                            :key="item.id"
                            :label="item.channel_name"
                            :value="item.channel_no">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="时间">
                    <el-date-picker v-model="start_time" type="date" value-format="YYYY-MM-DD" placeholder="请选择开始日期"></el-date-picker>
                    --
                    <el-date-picker v-model="end_time" type="date" value-format="YYYY-MM-DD" placeholder="请选择结束日期"></el-date-picker>
                </el-form-item>
                <el-form-item style="width:100%;text-align:center">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="onExport()">确 定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import {useRouter} from 'vue-router'
import { useStore } from '@/store/index'
import { defineComponent, getCurrentInstance, toRefs, reactive } from 'vue'
import Keys from '@/constant/key'
import { joinParams } from '@/utils'
import Pagination from '@/components/Pagination'
export default defineComponent({
name: 'InvoiceList',
components: {Pagination },
setup() {
    const { proxy } = getCurrentInstance()
    const router = useRouter()
    const store = useStore()
    
    const data = reactive({
        filters: {
            date: '',
            order_type: '',
            status:'',
            remittance_status:'',
            invoice_type:'',
            pageSizes: 10,
            currentPage: 1
        },
        exportType:     0,      // 导出类型：0-普通导出，1-结算订单导出，2-退款订单导出
        tableData:      [],
        dateList:       [],
        count:          0,
        
        dialogVisible:  false,  // 结算订单导出弹框
        dialogType:     1,      // 弹框类型：1-结算订单导出；2-结算订单预导出申请
        channelList:    [],     // 渠道列表
        channel_no:     '',     // 当前选中渠道
        start_time:     '',     // 导出开始时间
        end_time:       '',     // 导出结束时间
        exportArray:    ['普通订单','结算订单导出','退款订单导出','卡券sass结算订单导出'],
        onSizeChange(val){
            data.filters.pageSizes = val
            data.getList();
        },
        onPageChange(val) {
            data.filters.currentPage = val
            data.getList();
        },
        // 搜索
        search(){
            data.filters.currentPage = 1
            data.getList();
        },
        // 编辑
        edit(row){
            proxy.$confirm(`确定已经对账完成了吗？`, '提示', {
                type: 'warning',
                dangerouslyUseHTMLString: true
            }).then(() => {
                proxy.$http.get(`/admin/invoice/upAccountCheck?id=${row.id}`).then(res => {
                    if(res.code == 0){
                        proxy.$message({type:'success',message:res.msg});
                        location.reload()
                    }else{
                        proxy.$message({type:'error',message:res.msg});
                    }
                })
            });
        },
        // 查看
        show(row){
            router.push(`/invoice/showOrderList?id=${row.id}`);
        },
        //卡券Sass导出
        outSassOrder(){
            window.open(`${Keys.baseUrl}/cake_api/productChannelLog?${joinParams({...filters, user_id: store.state.user.userInfo.id})}&export_type=${type}`)
        },
        getList(){
            proxy.$http.get(`/admin/invoice/getAccountCheckList?date=${data.filters.date}&order_type=${data.filters.order_type}&status=${data.filters.status}&remittance_status=${data.filters.remittance_status}&invoice_type=${data.filters.invoice_type}&page=${data.filters.currentPage}&limit=${data.filters.pageSizes}`).then(res => {
                if(res.code == 0){
                    data.tableData = res.data;
                    data.count = res.count;
                }else{
                    data.tableData = [];
                }
                
            })
        },
        getDateList(){
            proxy.$http.get(`/admin/invoice/getDateList`).then(res => {
                if(res.code == 0){
                    data.dateList = res.data;
                }else{
                    data.dateList = [];
                }
            })
        },
        // 获取渠道列表
        getChannelList: () => {
            proxy.$http.get(`/dsapi/trade/channel_info`).then((res ) => {
                if(res.code == 200){
                    data.channelList = res.data;
                }else{
                    proxy.$message({type:'error',message:res.msg});
                }
            })
        },
        // 订单发票、汇款状态变更
        onOrderChange(id, type) {
            proxy.$confirm('确认要变更当前状态？', '提示', {
                type: 'warning'
            }).then(() => {
                let url = type===1 ? `/admin/merchant/doInvoiceStatus?id=${id}&invoice_status=1` : `/admin/merchant/doReconStatus?id=${id}&remittance_status=1`
                proxy.$http.get(url).then(res => {
                    const {code, msg} = res
                    if (code == 0) {
                        proxy.$message({
                            type: 'success',
                            message: '变更成功'
                        })
                        setTimeout(() => {
                            proxy.getList()
                        }, 2000)
                    } else {
                        proxy.$message({
                            type: 'error',
                            message: msg
                        })
                    }
                })
            }).catch(() => {
                console.log('取消状态变更')
            })
        },
        // 显示导出弹框
        onDialogShow () {
            const { getChannelList } = data
            getChannelList()
            data.channel_no = data.start_time = data.end_time = ''
            data.dialogVisible = true
        },
        // 导出
        onExport () {
            const { exportType, filters, channel_no, start_time, end_time } = data
            const { date, order_type, status, remittance_status, invoice_type } = filters
            const urlArr = [
                `/admin/invoice/accountOutPut?${joinParams({ date, order_type, status, remittance_status, invoice_type })}`, // 普通订单导出
                `/channel/export_order?${joinParams({channel_no, start_time, end_time})}`, // 结算订单导出
                `/channel/export_order?${joinParams({channel_no, start_time, end_time, refund: 1})}`, // 退款订单导出
                `/channel/export_coupon_order?${joinParams({channel_no, start_time, end_time})}`, // 卡券sass结算订单导出

            ]

            if (exportType === 1 || exportType === 2 || exportType ===3) {
                if (!channel_no) {
                    return proxy.$message({
                        type: 'error',
                        message: '请选择渠道号'
                    })
                }
                if (!start_time) {
                    return proxy.$message({
                        type: 'error',
                        message: '请选择开始日期'
                    })
                }
                if (!end_time) {
                    return proxy.$message({
                        type: 'error',
                        message: '请选择结束日期'
                    })
                }
            }

            window.open(`${Keys.baseUrl + urlArr[exportType]}`)
        }
    })
    data.getList()
    data.getDateList()
    return { ...toRefs(data) }
}
})
</script>

<style lang="stylus" scoped>
</style>